/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Dialogue_SuccessInputs */



/**
* | output |
* | --- |
* | "Dialogue and metadata copied from Track 2" |
*
* @param {Event_Group_Options_Copy_Dialogue_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_dialogue_success = /** @type {((inputs?: Event_Group_Options_Copy_Dialogue_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Dialogue_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Dialogue et métadonnées copiés depuis la piste 2")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dialoge und Metadaten aus Spur 2 kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dialogo e metadati copiati dalla traccia 2")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Диалоги и метаданные скопированы со второго трека.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Diálogo y metadatos copiados de la pista 2")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对话和元数据复制自轨道 2")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラック2からコピーされた会話とメタデータ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संवाद और मेटाडेटा ट्रैक 2 से कॉपी किए गए हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diálogo e metadados copiados da Faixa 2.")
	return /** @type {LocalizedString} */ ("Dialogue and metadata copied from Track 2")
});